import React from "react";
import { Outlet } from "react-router-dom";

const SettingsMaster: React.FC = () => {
  return <Outlet />;
};
export default SettingsMaster;
